export default __webpack_public_path__ + "static/media/grandsducsdesenfers.c6a62ff9.jpg";